import React, { Component } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
  Popover,
  PopoverContent
} from 'reactstrap';

// Import date airbnb
import DateRangePickerWrapper from './components/DateRangePickerWrapper.js';

//icon toggler
import IconToggler from '../../../components/Icon/';

// ==== Overide home css
import '../../../assets/custome/css/home.css';
import '../../../assets/custome/css/pretty-checkbox.css';

class BookaToolsScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalBooking        : false,
      popoverOpen         : false,
      popoverOpenFilter   : false,
      iconAsc             : 'icon-sort fa fa-sort-asc',
      iconDesc            : 'icon-sort fa fa-sort-desc',
    }

    this.toggleModalBooking     = this.toggleModalBooking.bind(this);
    this.togglePopOver          = this.togglePopOver.bind(this);
    this.togglePopOverFilter    = this.togglePopOverFilter.bind(this);
  }

  toggleModalBooking() {
    this.setState({
      modalBooking: !this.state.modalBooking
    });
  }

  togglePopOver() {
    this.setState({
      popoverOpen: !this.state.popoverOpen
    });
  }

  togglePopOverFilter() {
    this.setState({
      popoverOpenFilter: !this.state.popoverOpenFilter
    });
  }

  render() {
    return (
      <div className="animated fadeIn">
        <div className="row">
          {/* START Book a tool */}
          <div className="col-md-12">
            <div className="card">
              <div className="card-block">
                <div className="row">
                  <div className="col-sm-5 book-a-tool-title">
                    <h4 className="card-title mb-0"><span className="icon-calendar"></span>&nbsp;Book a Tools </h4>
                    <div className="text-muted m-top-8">
                      12.300 Total Asset/tool
                    </div>
                  </div>
                  <div className="col-sm-7 ">
                    <div className="input-group">
                      <div className="input-group-addon white-background">
                        <Button className="btn btn-link btn-filter" id="popoverFilter" onClick={this.togglePopOverFilter} ><i className="fa fa-filter"></i>&nbsp;Filter</Button>
                        <Popover placement="bottom" isOpen={this.state.popoverOpenFilter} target="popoverFilter" toggle={this.togglePopOverFilter}>
                          <PopoverContent>
                            <div className="row">
                              <div className="col-md-4">
                                <Label>Filter By : &nbsp;</Label>
                              </div>
                              <div className="col-md-8">
                                <div className="row">
                                  <div className="col-md-6">
                                    <div className="pretty p-default">
                                        <input type="checkbox" />
                                        <div className="state p-primary">
                                            <label>Asset</label>
                                        </div>
                                    </div>
                                    <div className="pretty p-default">
                                        <input type="checkbox" />
                                        <div className="state p-primary">
                                            <label>Vendor</label>
                                        </div>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="pretty p-default">
                                        <input type="checkbox" />
                                        <div className="state p-primary">
                                            <label>Site</label>
                                        </div>
                                    </div>
                                    <div className="pretty p-default">
                                        <input type="checkbox" />
                                        <div className="state p-primary">
                                            <label>Location</label>
                                        </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <hr/>
                            <div className="row">
                            <div className="col-md-6">
                              <Button href="" className="btn btn-sm btn-link btn-link-filter apple-red pointer">Clear all Filter</Button>
                            </div>
                              <div className="col-md-6">
                                <Button href="" className="btn btn-sm btn-link btn-link-filter apple-blue pointer pull-right" >Apply</Button>
                                <Button href="" className="btn btn-sm btn-link btn-link-filter apple-grey pointer pull-right">Cancel</Button>
                              </div>
                            </div>
                          </PopoverContent>
                        </Popover>
                      </div>
                      <Input type="text" className="form-control" placeholder="Search"/>
                    </div>
                    <div className="text-muted">
                      Filtered by :
                      <span className="badge badge-pill badge-success badge-filter-item">Asset</span>
                      <span className="badge badge-pill badge-success badge-filter-item">Site</span>
                    </div>
                  </div>
                </div>
                <table className="table table-responsive table-hover table-outline mb-0 m-top-15">
                  <thead className="thead-default">
                    <tr>
                      <th className="pointer"> Asset/Tool <IconToggler iconStart={this.state.iconAsc} iconFinish={this.state.iconDesc} /></th>
                      <th>Vendor Name <IconToggler/></th>
                      <th>Site <IconToggler/></th>
                      <th>Location <IconToggler/></th>
                      <th>Tags <IconToggler/></th>
                      <th className="text-center">Booking </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div>Drum (D787FF79AF6F479 )</div>
                        <div className="small text-muted">
                          Registered: 18 Oct 2017 | 5 day ago
                        </div>
                      </td>
                      <td><div>Officemax</div></td>
                      <td>
                        <div>Ngawi</div>
                      </td>
                      <td>
                        <div>Magetan</div>
                      </td>
                      <td>
                        <div className="tagcontainer">
                          <div className="tags">Dram</div>
                          <div className="tags">Music</div>
                        </div>
                      </td>
                      <td className="text-center">
                        <button className="btn-badge btn-primary" onClick={this.toggleModalBooking}>Booking</button>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div>New Honda CBR250cc ( E917B5E7C53C41D )</div>
                        <div className="small text-muted">
                          Registered: 18 Oct 2017 | 5 day ago
                        </div>
                      </td>
                      <td><div>Officemax</div></td>
                      <td>
                        <div>Surabaya</div>
                      </td>
                      <td>
                        <div>Bukit Duri</div>
                      </td>
                      <td>
                        <div className="tagcontainer">
                          <div className="tags">Music</div>
                        </div>
                      </td>
                      <td className="text-center">
                        <button className="btn-badge btn-primary" onClick={this.toggleModalBooking}>Booking</button>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div>New Honda CBR250cc ( E917B5E7C53C41D )</div>
                        <div className="small text-muted">
                          Registered: 18 Oct 2017 | 5 day ago
                        </div>
                      </td>
                      <td><div>Officemax</div></td>
                      <td>
                        <div>Surabaya</div>
                      </td>
                      <td>
                        <div>Bukit Duri</div>
                      </td>
                      <td>
                        <div className="tagcontainer">
                          <div className="tags">Dram</div>
                          <div className="tags">Music</div>
                          <div className="tags">Music</div>
                          <div className="tags" id="Popover1" onClick={this.togglePopOver}><i className="icon-options"></i></div>
                          <Popover placement="bottom" isOpen={this.state.popoverOpen} target="Popover1" toggle={this.togglePopOver}>
                            <PopoverContent>
                              <div className="tags">Music Rock</div>
                              <div className="tags">Music Rege</div>
                              <div className="tags">Music Pop</div>
                              <div className="tags">Music Jazz</div>
                            </PopoverContent>
                          </Popover>
                        </div>
                      </td>
                      <td className="text-center">
                        <button className="btn-badge btn-primary" onClick={this.toggleModalBooking}>Booking</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {/* END */}

          {/* MODAL Booking */}
          <Modal isOpen={this.state.modalBooking} toggle={this.toggleModalBooking} className={this.props.className}>
            <ModalHeader toggle={this.toggleModalBooking}>Booking Tools</ModalHeader>
            <ModalBody>
              <div className="row">
                <div className="form-group col-sm-6">
                  <label htmlFor="asset">Asset / Tools</label>
                  <input type="text" className="form-control" id="asset" value="Drum (D787FF79AF6F479 )" disabled/>
                </div>
                <div className="form-group col-sm-6">
                  <label>Booking Date</label>
                  <DateRangePickerWrapper/>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={this.toggleModalBooking}>Cancel</Button>
              <Button color="primary" onClick={this.toggleModalBooking}>Ok</Button>{' '}
            </ModalFooter>
          </Modal>
          {/* End MODAL Booking */}

        </div>
      </div>
    )
  }

}
export default BookaToolsScreen;


// WEBPACK FOOTER //
// ./src/App/views/templates/dashboard/home/book_a_tool.js